import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, EventEmitter, Injector, OnInit, Output, ViewChild } from '@angular/core';
import { MontwiseImportAttandanceComponent } from '@app/main/import-component/montwise-import-attandance/montwise-import-attandance.component';
import { IFormattedUserNotification, UserNotificationHelper } from '@app/shared/layout/notifications/UserNotificationHelper';
import { dateToLocalArray } from '@fullcalendar/core/datelib/marker';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AssetMasterServiceProxy, AssetServiceProxy, CreateOrEditAssetDto, CreateOrEditAssetMasterDto, CreateOrEditTrnAssetMasterDetailsDto, DropDown, DropDownEmployee, DropdownServicesServiceProxy, GetAssetForEditOutput, GetAssetForViewDto, TrnAssetMasterDetailsesServiceProxy } from '@shared/service-proxies/service-proxies';
import { id } from '@swimlane/ngx-charts/release/utils';
import * as moment from 'moment';
import { ModalDirective } from 'ngx-bootstrap';
import { Dropdown, Paginator } from 'primeng/primeng';
import { Table } from 'primeng/table';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-aknwledge-assign-assest',
  templateUrl: './aknwledge-assign-assest.component.html',
  styleUrls: ['./aknwledge-assign-assest.component.css']
})
export class AknwledgeAssignAssestComponent extends AppComponentBase {

 @ViewChild('createOrEditAsset', { static: true }) modal: ModalDirective;
   @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();
   @ViewChild('dataTable', { static: true }) dataTable: Table;
   @ViewChild('paginator', { static: true }) paginator: Paginator;
 currentUserNotification: IFormattedUserNotification;

   enabledisable: boolean = false;
   returnAssignDate: moment.Moment;
   assign = false;
   return = false;
   Edit = false;
   active = false;
   saving = false;
   filterText = "";
   nameFilter = "";
   assignReturn: any;
   minDate = new Date();
 
   Asset: CreateOrEditAssetMasterDto = new CreateOrEditAssetMasterDto;
   Assigned: CreateOrEditTrnAssetMasterDetailsDto = new CreateOrEditTrnAssetMasterDetailsDto;
   trnAsset: Array<CreateOrEditTrnAssetMasterDetailsDto>;
 
   AssetType: DropDown[];
   employeeData: DropDownEmployee[];
   employeeId: string;
  AknowledgeAssestId: number;
 
   constructor(
     injector: Injector,
     private _AssetMasterServiceProxy: AssetMasterServiceProxy,
     private _AssetAserviceProxy: AssetServiceProxy,
     private _dropdownServiceProxy: DropdownServicesServiceProxy,
     private _trnAssetMasterDetailsesServiceProxy: TrnAssetMasterDetailsesServiceProxy,
             private _userNotificationHelper: UserNotificationHelper,
     
 
   ) {
     super(injector);
     (moment as any).fn.toString = function () { return this.format('DD/MM/YYYY'); };
   }
 
   onShown() {
     document.getElementById("AssetName").focus();
   }
   ngOnInit() {
     this.returnAssignDate = moment().startOf('day');
 
   }
  setNotificationAsRead(userNotification: IFormattedUserNotification): void {
         debugger;
         this._userNotificationHelper.setAsRead(userNotification.userNotificationId);
     }
 
 
  show(assetId: number, type: 'A' | 'R',userNotification?: IFormattedUserNotification): void {
  this.assignReturn = type;
  console.log("assign task :-",this.assignReturn)
this.AknowledgeAssestId=assetId
  // Fetch the asset details
    this.currentUserNotification = userNotification;

  this._AssetMasterServiceProxy.getAssetMasterForEdit(assetId).subscribe(result => {
    this.Asset = result.assetM;
   this.filterAsstests(this.Asset.assetTypeId); 
    this.filterAssignTo();

    this.minDate = moment(this.Asset.assignDate).toDate();

    // Assign Mode
    if (this.assignReturn === 'A') {
      this.assign = true;
      this.return = false;
      this.enabledisable = true;
    }

    // Return Mode
    if (this.assignReturn === 'R') {
      this.return = true;
      this.assign = false;
      this.employeeId = result.employeeId;
      this.enabledisable = true;
    }

    this.active = true;
    this.modal.show();
  });
}

 
 
  filterAsstests(assetTypeId?: number) {
  this._AssetAserviceProxy.getAssets().subscribe(Customer => {
    this.AssetType = Customer;

    // Set the selected assetTypeId after options are loaded
    if (assetTypeId) {
      this.Asset.assetTypeId = assetTypeId;
    }
  });
}

   filterAssignTo() {
 
     this._dropdownServiceProxy.getEmployeesForExpense().subscribe(res => {
       this.employeeData = res;
     });
 
 
   }
 
   // getUser() {  
   //   
   //    this._dropdownServiceProxy.getEmployeesForExpense().subscribe(result => {
   //      this.employeeData=result;
 
   //   });
   // }


 
   save(): void {
      this._AssetMasterServiceProxy.acknowledgeAsset(Number(this.currentUserNotification.data.properties.tranId))
                  .pipe(finalize(() => {})).subscribe(() => {
                    
                                this.setNotificationAsRead(this.currentUserNotification);

                    this.notify.info(this.l('Acknowledge Sucessfully'));
                    this.modal.hide();
                  });
 
   }
 
 
 
 
   close(): void {
     this.active = false;
     this.modal.hide();
   }
 }
 
